import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircleIcon, RocketIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
export function SponsorshipPilotPage() {
  const deliverables = ['Build a list of target brands that match your audience', 'Find the right decision-makers (with enriched contact info)', 'Craft personalized outreach and follow-ups', 'Track opens/clicks/responses', 'Handle invoicing, collections, and reporting', 'Turn brand sponsors into repeat customers'];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2153">
      <Header data-id="element-2154" />

      <main className="flex-grow pt-36 pb-24" data-id="element-2155">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2156">
          {/* Hero Section */}
          <div className="text-center mb-16" data-id="element-2157">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-2158">
              Landing Sponsorships Can Be{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-2159">
                Huge for Your Creator Business
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-2160">
              But actually getting them is a grind.
            </p>
          </div>

          {/* Problem Statement */}
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-16" data-id="element-2161">
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-2162">
              Finding the right brands… Tracking down decision-makers…
              Personalizing outreach… Following up (again and again)… And making
              sure you get paid on time…
            </p>
            <p className="text-xl font-semibold text-gray-900" data-id="element-2163">
              It's a full-time job. So we built a solution.
            </p>
          </div>

          {/* Solution Section */}
          <div className="mb-16" data-id="element-2164">
            <div className="text-center mb-12" data-id="element-2165">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl mb-4" data-id="element-2166">
                <RocketIcon className="w-8 h-8 text-white" data-id="element-2167" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-2168">
                Introducing Our 30-Day Sponsorship Pilot
              </h2>
              <p className="text-xl text-gray-600" data-id="element-2169">
                We become your sponsorship engine
              </p>
            </div>

            {/* Deliverables Grid */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12" data-id="element-2170">
              <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-2171">
                What We Do For You:
              </h3>
              <div className="space-y-4" data-id="element-2172">
                {deliverables.map((item, index) => <div key={index} className="flex items-start" data-id="element-2173">
                    <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-2174" />
                    <p className="text-lg text-gray-700" data-id="element-2175">{item}</p>
                  </div>)}
              </div>
              <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-2176">
                <p className="text-xl font-semibold text-gray-900 text-center" data-id="element-2177">
                  You create the content. We handle the business development.
                </p>
              </div>
            </div>
          </div>

          {/* Guarantee Section */}
          <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12 mb-16 text-white" data-id="element-2178">
            <div className="flex items-center justify-center mb-6" data-id="element-2179">
              <ShieldCheckIcon className="w-12 h-12" data-id="element-2180" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-2181">
              The Guarantee
            </h2>
            <div className="max-w-2xl mx-auto space-y-4 text-lg" data-id="element-2182">
              <p className="text-center" data-id="element-2183">
                The pilot is{' '}
                <span className="font-bold text-2xl" data-id="element-2184">$500 for 30 days</span>.
              </p>
              <p className="text-center text-xl font-semibold" data-id="element-2185">
                If we don't get you at least 3 sponsor meetings, we keep working
                for free until we do.
              </p>
              <div className="grid grid-cols-3 gap-4 mt-8 text-center" data-id="element-2186">
                <div data-id="element-2187">
                  <p className="font-bold text-2xl" data-id="element-2188">No risk</p>
                </div>
                <div data-id="element-2189">
                  <p className="font-bold text-2xl" data-id="element-2190">No fluff</p>
                </div>
                <div data-id="element-2191">
                  <p className="font-bold text-2xl" data-id="element-2192">Just results</p>
                </div>
              </div>
            </div>
          </div>

          {/* Urgency + CTA Section */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12 text-center" data-id="element-2193">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-2xl mb-6" data-id="element-2194">
              <UsersIcon className="w-8 h-8 text-orange-600" data-id="element-2195" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-2196">
              Limited Spots Available
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-2197">
              We're only taking a few creators for this pilot so we can stay
              hands-on and deliver exceptional results.
            </p>
            <a href="https://forms.gle/YQUnsyysZkZYoA668" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-2198">
              Fill Out The Form →
            </a>
            <p className="text-sm text-gray-500 mt-4" data-id="element-2199">
              Secure your spot in the pilot program
            </p>
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center" data-id="element-2200">
            <p className="text-gray-600 mb-6" data-id="element-2201">
              Ready to turn sponsorships into a reliable revenue stream?
            </p>
            <a href="https://forms.gle/YQUnsyysZkZYoA668" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors" data-id="element-2202">
              Apply Now
            </a>
          </div>
        </div>
      </main>

      <Footer data-id="element-2203" />
    </div>;
}